<template>
  <div class="content-tab qos">
    <loading :mask=true :size="'big'" :isWhite=true v-if="isShowLoading"/>
    <div class="content-body">
      <div class="describe">
        {{$t('qos.describe')}}
        <div class="note">
          <icon-remind class="remind"></icon-remind>
          <span class="title">{{$t('qos.note')}}</span>
        </div>
      </div>
      <div class="content-body-header">
        <button class="q-button blue-btn-full footer-btn" @click="onEditClick('dscp')" :title="$t('qos.editDscp')">{{$t('qos.editDscp')}}</button>
        <button class="q-button blue-btn-full footer-btn" @click="onEditClick('pcp')" :title="$t('qos.editCos')">{{$t('qos.editCos')}}</button>
      </div>
      <div class="table-content" ref="tableContent">
        <div class="group-table">
          <fixed-table ref="portTable" :data="qosList" :use-page="false" :header-height="40">
            <div class="right-header" slot="right-header">
              <column style="width: 20%;">{{$t('overview.portNo')}}</column>
              <column style="width: 25%;">{{$t('qos.dscp')}}</column>
              <column style="width: 25%;">{{$t('qos.cos')}}</column>
              <column style="width: 30%;">{{$t('qos.priority')}}<span style="padding-left:5px;color:#195A87;">{{$t('qos.priorityScope')}}</span>
              <span ref="infoTips" class="icon-info info-color ft-14 tempInfo" @click="onInfoClick"></span>
              </column>
            </div>
            <template slot="rows" slot-scope="props">
              <div class="link-row">
                <row class="right" :props="props" :title="getTooltips(props.data.key)">
                  <div class="data" style="width: 20%;">{{getKey(props.data.key)}}</div>
                  <div class="data" style="width: 25%;">
                    <toggle :on="props.data.val === 2" @click.native="onSwitchBtn(props, 'dscp')" v-if="props.data.val" :disabled="getDisabled(props.data.key)"></toggle>
                  </div>
                  <div class="data" style="width: 25%;">
                    <toggle :on="props.data.val === 1" @click.native="onSwitchBtn(props, 'pcp')" v-if="props.data.val" :disabled="getDisabled(props.data.key)"></toggle>
                  </div>
                  <div class="data priority" style="width: 30%;">
                    <div class="icon-line" @click="decressPriority(props)" :class="{'disabled': (props.data.priority === 0 || getDisabled(props.data.key))}"></div>
                    <input :name="'priority' + props.index" class="form-control priority-input" :class="{'error': errors.has('priority' + props.index)}" v-model="props.data.priority" v-validate="'required|numeric|max_value:7|min_value:0'" @change="onBlur" min="0" max="7" maxlength="1" :disabled="getDisabled(props.data.key)" @input="onInput" @keypress="onlyNumber">
                    <div class="icon-plus" @click="incressPriority(props)" :class="{'disabled': (props.data.priority === 7 || getDisabled(props.data.key))}"></div>
                  </div>
                </row>
              </div>
            </template>
          </fixed-table>
        </div>
      </div>
      <div class="content-body-footer">
        <button class="q-button blue-btn-full right" :title="$t('save')" @click="onSaveClick()" :disabled="!isButtonEnable">{{$t('save')}}</button>
      </div>
    </div>
    <qos-item :selectType="selectType" :onChange="onChange"></qos-item>
  </div>
</template>

<script>
import fixedTable from './table/FixedTable'
import row from './table/row/Row'
import column from './table/column/Column'
import toggle from './module/Toggle'
import qosItem from './QosItem'
import iconRemind from '../assets/svg/ic_system_remind.svg'
import { mapActions, mapState, mapGetters, mapMutations } from 'vuex'
export default {
  name: 'Qos',
  components: {
    fixedTable,
    row,
    column,
    toggle,
    qosItem,
    iconRemind
  },
  data () {
    return {
      isShowLoading: false,
      qosList: null,
      isQosEnable: false,
      isDisabled: true,
      isButtonEnable: false,
      originalData: null,
      selectType: null
    }
  },
  created: async function () {
    this.getData()
  },
  beforeRouteLeave (to, from, next) {
    if (this.isDataChanged) {
      next(false)
    } else {
      next()
    }
  },
  watch: {
    currentUser: {
      handler (value) {
        if (this.currentUser.auth !== undefined) {
          // this.getQosEnable()
        }
      },
      immediate: true,
      deep: true
    },
    isButtonEnable: function (value) {
      this.$store.commit('updateDataChanged', value)
    },
    showQuickHelp: {
      handler (value) {
        if (value) {
          setTimeout(() => {
            this.$refs.tableContent.style.height = 'calc(100% - 150px)'
          }, 250)
        } else {
          setTimeout(() => {
            this.$refs.tableContent.style.height = 'calc(100% - 130px)'
          }, 130)
        }
      },
      immediate: true
    }
  },
  methods: {
    ...mapActions(['getQosMode', 'setQosMode', 'getQosDefault', 'setQosDefault']),
    ...mapMutations(['openModal', 'closeModal']),
    getData: function () {
      let me = this
      this.isShowLoading = true
      this.isButtonEnable = false
      this.originalData = null
      this.axios.all([this.getQosMode(), this.getQosDefault()])
        .then(this.axios.spread(function (mode, priority, dscp, pcp) {
          let tempArray = null
          if (mode.data && mode.data.error_code === 200) {
            tempArray = mode.data.result.splice(0, me.portNumber)
            for (let index = 0; index < me.lagGroupMap.size; index++) {
              tempArray.push({
                key: index + me.lagStartNum + 1,
                priority: 0
              })
            }
          }
          if (priority.data && priority.data.error_code === 200) {
            let data = priority.data.result
            data.forEach((element) => {
              let elKey = Number(element.key)
              let port = null
              if (elKey <= me.portNumber || (elKey > me.lagStartNum && elKey <= me.lagStartNum + me.lagGroupMap.size)) {
                if (me.sysBoard.Product.includes('M804')) {
                  port = (elKey > me.lagStartNum) ? elKey - 5 : elKey - 1
                } else if (me.sysBoard.Product.includes('M2108') || me.sysBoard.Product.includes('M2106')) {
                  port = (elKey > me.lagStartNum) ? elKey - me.lagStartNum + 9 : elKey - 1
                } else if (me.sysBoard.Product.includes('M5216')) {
                  port = elKey - 1
                } else {
                  port = (elKey > me.lagStartNum) ? elKey - me.lagStartNum + 11 : elKey - 1
                }
                tempArray[port]['priority'] = element.val
                if (me.lagGroupMap.get(element.key)) {
                  let val = me.lagGroupMap.get(element.key)
                  val.forEach(item => {
                    tempArray[Number(item) - 1]['priority'] = 0
                  })
                }
              }
            })
          }
          me.qosList = tempArray
          me.originalData = JSON.parse(JSON.stringify(tempArray))
          me.isShowLoading = false
        })).catch((err) => {
          this.$log.error(err)
        })
    },
    getKey: function (key) {
      let num = Number(key)
      if (num > this.portNumber) {
        return 'LAG ' + (num - this.lagStartNum)
      } else {
        return num
      }
    },
    getDisabled: function (port) {
      if (this.portMap.get(Number(port))) {
        return true
      } else {
        return false
      }
    },
    decressPriority: function (props) {
      let idx = props.index
      let priority = props.data.priority
      if (priority > 0) {
        this.qosList[idx].priority--
        this.onInput(props)
      }
    },
    incressPriority: function (props) {
      let idx = props.index
      let priority = props.data.priority
      if (priority < 7) {
        this.qosList[idx].priority++
        this.onInput(props)
      }
    },
    onSwitchBtn: function (props, type) {
      let idx = props.index
      let mode = props.data.val
      if (type === 'pcp') {
        if (mode === 1) {
          this.qosList[idx].val = 3
        } else if (mode === 2 || mode === 3) {
          this.qosList[idx].val = 1
        }
      } else if (type === 'dscp') {
        if (mode === 1 || mode === 3) {
          this.qosList[idx].val = 2
        } else if (mode === 2) {
          this.qosList[idx].val = 3
        }
      }
      this.checkValidation()
    },
    onSelect ($event) {
      $event.target.onSelect = true
    },
    onBlur ($event) {
      $event.target.onSelect = false
    },
    onInput: function ($event) {
      var temp = /^[0-7]{1}$/
      let value = ($event.key) ? parseInt($event.key) : ($event.data) ? $event.data.priority : ''
      let name = ($event.target) ? $event.target.name : 'priority' + $event.index
      if (!temp.test(value) || value === '') {
        this.isButtonEnable = false
      }
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.checkValidation(name)
        } else {
          this.isEnable = false
        }
      })
    },
    checkValidation: function (fieldName) {
      this.qosList.forEach(element => {
        element['priority'] = Number(element['priority'])
      })
      if (fieldName) {
        setTimeout(() => {
          this.$validator.validate(fieldName).then((result) => {
            if (result) {
              if (!this.$compareObj(this.qosList, this.originalData)) {
                this.isButtonEnable = true
              } else {
                this.isButtonEnable = false
              }
            } else {
              this.isButtonEnable = result
            }
          })
        }, 100)
      } else {
        if (!this.$compareObj(this.qosList, this.originalData)) {
          this.isButtonEnable = true
        } else {
          this.isButtonEnable = false
        }
      }
    },
    checkChangedItem: function () {
      let data = {
        modeIdx: [],
        priorityIdx: []
      }
      this.qosList.forEach((element, index) => {
        if (element.val !== this.originalData[index].val) {
          data.modeIdx.push({
            key: element.key,
            val: element.val
          })
        }
        if (element.priority !== this.originalData[index].priority) {
          data.priorityIdx.push({
            key: element.key,
            val: element.priority
          })
        }
      })
      return data
    },
    onSaveClick: function () {
      let me = this
      let count = this.checkChangedItem()
      let modeLength = count.modeIdx.length
      let priLength = count.priorityIdx.length
      this.isShowLoading = true
      function checkSetDone () {
        if (modeLength === 0 && priLength === 0) {
          me.getData()
        }
      }
      count.modeIdx.forEach(element => {
        this.setQosMode(element)
          .then((res) => {
            if (res.data && res.data.error_code === 200) {
              modeLength--
            }
            checkSetDone()
          }).catch((err) => {
            this.$log.error(err)
          })
      })
      count.priorityIdx.forEach(element => {
        this.setQosDefault(element)
          .then((res) => {
            if (res.data && res.data.error_code === 200) {
              priLength--
            }
            checkSetDone()
          }).catch((err) => {
            this.$log.error(err)
          })
      })
    },
    onEditClick: function (type) {
      this.selectType = type
      this.openModal('qos-item-modal')
      this.$modal.show('qos-item-modal')
    },
    onChange: function () {
      this.selectType = null
    },
    onInfoClick: function (event) {
      let message = [{text: this.$t('qos.priorityInfo')}]
      this.$store.commit('updateInfoTips', !this.showInfoTips)
      if (this.showInfoTips) {
        this.$store.commit('updateInfoData', {
          message: message,
          event: event
        })
      }
    },
    onlyNumber ($event) {
      let keyCode = ($event.keyCode ? $event.keyCode : $event.which)
      if (keyCode < 47 || keyCode > 55) {
        $event.preventDefault()
      }
    },
    getTooltips: function (key) {
      if (this.portMap.get(Number(key))) {
        return this.$t('qos.lagTips')
      } else {
        return ''
      }
    }
  },
  computed: {
    ...mapState({
      sysBoard: state => state.module.sysBoard,
      showInfoTips: state => state.app.showInfoTips,
      portNumber: state => state.module.portNum,
      currentUser: state => state.module.currentUser,
      isDataChanged: state => state.app.isDataChanged,
      lagGroupMap: state => state.module.lagGroupMap,
      portMap: state => state.module.portMap,
      showQuickHelp: state => state.app.showQuickHelp,
      lagStartNum: state => state.module.lagStartNum
    }),
    ...mapGetters(['getSwVersion'])
  }
}
</script>

<style lang="scss" scoped>

.qos {
  position: relative;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  .content-body {
    padding: 10px;
    .describe {
      margin-bottom: 10px;
      >.note {
        font-family: 'Roboto-R';
        font-size: 14px;
        color: #195A87;
        text-align: left;
        line-height: 18px;
        margin: 10px 0px;
        svg {
          vertical-align: top;
        }
        .remind {
          width: 16px;
          height: 18px;
          margin-right: 10px;
        }
      }
    }
    .content-body-header {
      justify-content: flex-end;
      display: flex;
      > button:first-child {
        margin-right: 20px;
      }
    }
    .table-content {
      height: calc(100% - 160px) !important;
      >.group-table{
        height: 100%;
        width: 100%;
        .data.priority {
          display: flex !important;
          justify-content: start;
          margin: auto;
          .priority-input {
            width: 50px;
            margin: 0px 10px;
          }
          div {
            margin: auto 0px;
            cursor: pointer;
            &.disabled {
              opacity: 0.5;
              cursor: default;
              pointer-events: none;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Qos.vue